import Highcharts from 'highcharts';

export const chartReflow = () => {
    Highcharts.charts.forEach(chart => {
        setTimeout(() => {
            chart?.reflow();
        }, 10);
    });
};
